<template>
  <FormGroup :label="label" :inputId="idCalc" :errors="errorsCalc" :successes="successes">
    <select
      :class="{ 'is-invalid': errorsCalc, 'is-valid': successes }"
      :data-test="testId"
      :id="idCalc"
      :name="name"
      :placeholder="placeholder"
      @change="setApp"
    >
      <option :value="null"> - {{ $t("global.select-app") }} - </option>
      <optgroup :label="$t('global.ecommerce')">
        <option v-for="app in ecommApps" :key="app.id" :value="app.id" :selected="isSelected(app)">
          {{ app.name }}
        </option>
      </optgroup>
      <optgroup :label="$t('global.content-management')">
        <option v-for="app in cmsApps" :key="app.id" :value="app.id" :selected="isSelected(app)">
          {{ app.name }}
        </option>
      </optgroup>
      <optgroup :label="$t('global.crm')">
        <option v-for="app in crmApps" :key="app.id" :value="app.id" :selected="isSelected(app)">
          {{ app.name }}
        </option>
      </optgroup>
    </select>
  </FormGroup>
</template>

<script>
import { computed } from "@vue/composition-api";
import FormGroup from "@/components/display/form/FormGroup";
import FormMixin from "@/components/display/form/FormMixin";

export default {
  name: "FormAppSelect",
  components: {
    FormGroup,
  },
  mixins: [FormMixin],
  props: {
    value: [Number, String],
    apps: {
      type: Array,
      validator: (vals) => {
        if (!Array.isArray(vals)) {
          return false;
        }

        return vals;
      },
    },
  },
  setup(props, { emit }) {
    const appCategories = {
      ecomm: ["magento", "woocommerce", "bigcommerce", "sylius"],
      cms: ["wordpress", "craftcms", "drupal", "expressionengine"],
      crm: ["orocrm"],
    };

    const ecommApps = computed(() =>
      props.apps.filter((app) => appCategories["ecomm"].includes(app.type)).reverse()
    );

    const cmsApps = computed(() =>
      props.apps.filter((app) => appCategories["cms"].includes(app.type)).reverse()
    );

    const crmApps = computed(() =>
      props.apps.filter((app) => appCategories["crm"].includes(app.type)).reverse()
    );

    const setApp = (e) => {
      const appId = e.target.value;
      emit("input", Number(appId));
    };

    const isSelected = (app) => String(app.id) === String(props.value);

    return {
      setApp,
      appCategories,
      ecommApps,
      cmsApps,
      crmApps,
      isSelected,
    };
  },
};
</script>
<style lang="scss" scoped></style>
